import { defineAsyncComponent } from 'vue';
import {
  mountVueComponent,
} from '@/components/mountVueComponents';

const testCont = document.querySelector('.js-list-test');
if (testCont) {
  const test = defineAsyncComponent(() => import('./ListingTests.vue'));
  mountVueComponent(testCont, test, 'Listing-Test');
}
